import { useContext } from 'react'

import { GlobalModalContext } from './GlobalModalContext'

export default function useGlobalModal() {
  const globalModalContext = useContext(GlobalModalContext)

  return globalModalContext
}
